import React from 'react'
import PropTypes from 'prop-types'

function ScheduleTable ({ children, border }) {
  return (
    <div className='w-full pt-8'>
      <div className='flex group space-x-4'>
        {children}
      </div>
    </div>
  )
}

ScheduleTable.defaultProps = {
}

ScheduleTable.propTypes = {
}

export default ScheduleTable
